import { getAuthState } from '../common/utils/Sparky'
import Avatar from '../common/components/avatar/Avatar'

const TsgNavIcon = () => {
  const tsgSignature = getAuthState()?.tsg_name?.slice(0, 2) || ''
  return <Avatar letter={tsgSignature} />
}

export default TsgNavIcon
